import categories from "@/constants/categories.js";
import topicsServices from '@/services/topics.services.js';
import entitiesServices from '@/services/entities.services.js';
import sections from "@/constants/sections.enum.js";
import mixin from "@/mixin/index.js";
const { _getLabel } = mixin.methods;

const root = { root: true };

export default {
    async openTopic({ state, dispatch, commit }, id) {
        try {

            commit("general/setLoadingOn", null, root);
            dispatch("drugs/clearNavigationHistory", null, root);
            state.topic = sections['sections'].find(s => {
                return s.id == id;
            });
            const logEvent = {
                'foods': 'openFoodTopic', 'diagnostic-tools': 'openDiagnosticTools'
            }[id] || 'openTopic';
            dispatch("general/logEvent", { name: logEvent, object: { id } }, root);

            if (!!state.topic.subtopic) {
                state.isCategoryTopic = false;
                return dispatch('general/routePathRedirect', { path: `/items/subtopics/${state.topic.subtopic}` }, root);
            } else if (!['foods', 'diagnostic-tools'].includes(id)) {
                state.isCategoryTopic = false;
                const { topics } = await entitiesServices.getItem('configuration', 'topics');
                state.subtopics = topics.filter(topic => {
                    return topic.id == id;
                })[0].subtopics.filter(subtopic => {
                    return !!subtopic.available;
                });
            } else {
                state.isCategoryTopic = true;
                state.subtopics = categories.filter((c) => {
                    return {
                        foods: [8, 9],
                        "diagnostic-tools": [12, 13],
                    }[id].includes(c.id);
                });
            }

            if (state.subtopics.length == 1) {
                dispatch('general/routePathRedirect',
                    { path: `/items/subtopics/${state.subtopics[0].id}` }, root)
            } else {
                commit('setTopicsModel', true);
            }
        } catch {
            dispatch("general/showError", null, root);
        } finally {
            commit("general/setLoadingOff", null, root);
        }
    },
    async openSubtopic({ dispatch, commit, state }, id) {
        try {
            dispatch("general/logEvent", { name: "openSubtopic", object: { id } }, root);
            commit('drugs/setCategory', {
                id,
                collection: id,
                productsCollection: id,
                vaccines_suplements_serums: true,
                human_products: false,
                displayProducts: false,
                hideBrandSelection: true,
            }, root);
            const { items, topic_id, disclaimer } = await topicsServices.getSubtopic(id);
            state.topic = sections.sections.find(s => {
                return s.id == topic_id;
            });
            state.topicsNews[state.topic.name].text = disclaimer;
            let summary = {};
            summary[id] = items;
            commit('drugs/setDrugsSummary', summary, root);
            let summaryProdutcs = {}
            summaryProdutcs[id] = [];
            commit('drugs/setProductsSummary', summaryProdutcs, root);
        } catch (err) {
            dispatch("general/showError", null, root);
            dispatch('general/routeRedirect', { name: 'home' }, root);
        }
    },
    async openTopicItem({ commit, dispatch, state, rootGetters }, { itemId, topicId = 'topics', redirectMode = false }) {
        try {
            if (!redirectMode || topicId === 'calculators') {
                commit("general/setLoadingOn", true, root);
                const stateHasItem = !!state.item && state.item.id === itemId;

                if (rootGetters['management/algorithm']) {
                    state.item = rootGetters['management/algorithm'];
                } else if (!stateHasItem) {
                    state.itemContent = null;
                    commit('setClickedReferences', []);
                    state.item = await topicsServices.getItem(topicId, itemId);
                }

                if (topicId !== 'calculators') {
                    state.topic = sections.sections.find(s => {
                        return s.id == state.item.topic_id;
                    });
                    const analyticsEvents = { name: 'openTopicItemById', object: { 'id': state.topic.id } };
                    dispatch("general/logEvent", analyticsEvents, root);
                    if (!!state.item.tree) {
                        dispatch('general/showDisclaimer', null, root);
                        dispatch("general/logEvent", 'openAlgorithmById', root);
                        dispatch('algorithms/openAlgorithmByIdAsync', { tree: state.item.tree, treeLoaded: stateHasItem }, root);
                    }
                }
            } else {
                dispatch('general/routePathRedirect', { path: `/item/${itemId}` }, root);
            }
            return true;
        } catch (err) {
            if (!!err && !!err.response && err.response.status == 403) {
                dispatch("purchases/openPurchases", null, root);
            } else {
                dispatch("general/showError", null, root);
            }
            if (!redirectMode) {
                dispatch('general/routeBack', null, root);
            }
            return false;
        } finally {
            commit("general/setLoadingOff", true, root);
        }
    }
}